import { useParams } from 'react-router-dom';

export function useRequiredParam(key: string): string {
	const params = useParams();
	const value = params[key];
	if (value === undefined) {
		throw new Error(`Missing required route param: ${key}`);
	}
	return value;
}
